import React, { Component } from "react";
import axios from "axios";
import { APIURL } from "../../config/config";
import { Link } from "react-router-dom";
import BDatePicker from "../BDatePicker";
import { Button } from "reactstrap";
import { AlertWarning } from "../Alert/Alert";

class CustomerFollowupAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      followupSummary: [],
      followupUniqByName: [],
      customer_types: [],
      followupDateStart: "",
      followupDateEnd: "",
      reportBy: "by_date",
    };
    this.loadFollowupSummary = this.loadFollowupSummary.bind(this);
    this.loadCustomerTypes = this.loadCustomerTypes.bind(this);
    this.getCountByUser = this.getCountByUser.bind(this);
    this.getSumALl = this.getSumALl.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  async componentDidMount() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // เดือนใน JavaScript เริ่มจาก 0
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const followupDateStart = formatDate(firstDayOfMonth);
    const followupDateEnd = formatDate(today);
    await this.loadCustomerTypes();

    this.setState(
      {
        followupDateStart: followupDateStart,
        followupDateEnd: followupDateEnd,
      },
      () => {
        this.loadFollowupSummary();
      }
    );
  }

  loadFollowupSummary() {
    let followupDateStart = this.state.followupDateStart;
    let followupDateEnd = this.state.followupDateEnd;
    let reportBy = this.state.reportBy;
    let customer_types = this.state.customer_types;

    if (reportBy == "by_date") {
      if (followupDateStart === null || followupDateEnd === null) {
        AlertWarning("กรุณาเลือกวันที่");
        return;
      }
    }

    const customerTypesArray = customer_types.map((item) => item.customer_type);

    let uri = APIURL + "/customer/followup/summary";
    // date_start, date_end, report_by
    // console.log(customerTypesArray);
    axios
      .get(uri, {
        params: {
          date_start: followupDateStart,
          date_end: followupDateEnd,
          report_by: reportBy,
          customer_types: customerTypesArray,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          let data = res.data;
          this.setState({
            followupSummary: data.followupSummary,
            followupUniqByName: data.followupUniqByName,
          });
        }
      });
  }

  async loadCustomerTypes() {
    await axios
      .get(APIURL + "/customer/followup/customer_types")
      .then((res) => {
        this.setState({ customer_types: res.data });
      })
      .catch((error) => {
        this.setState({ customer_types: [] });
      });
  }

  getCountByCustomerType(followupSummary, username, customer_type) {
    let data = followupSummary.filter(
      (followup) =>
        followup.followup_by === username &&
        followup.customer_type === customer_type
    );
    if (data.length === 0) {
      return 0;
    }
    return data[0].count_customer_type;
  }

  getCountByUser(followupSummary, username) {
    let data = followupSummary.filter(
      (followup) => followup.followup_by === username
    );
    if (data.length === 0) {
      return 0;
    }
    let _ = require("lodash");
    let sum = _.sumBy(data, "count_customer_type");
    return sum;
  }

  getSumALl(followupSummary) {
    let _ = require("lodash");
    let sum = _.sumBy(followupSummary, "count_customer_type");
    return sum;
  }

  getAllByCustomerType(followupSummary, customer_type) {
    let data = followupSummary.filter(
      (followup) => followup.customer_type === customer_type
    );
    if (data.length === 0) {
      return 0;
    }
    let _ = require("lodash");
    let sum = _.sumBy(data, "count_customer_type");
    return sum;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "radio" ? target.value : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value === "by_all") {
      this.setState({
        followupDateStart: null,
        followupDateEnd: null,
      });
    } else if (value === "by_date") {
    }
  }

  render() {
    const {
      followupUniqByName,
      followupSummary,
      followupDateStart,
      followupDateEnd,
      reportBy,
      customer_types,
    } = this.state;

    let len = customer_types.length;

    let rowEmpty = (
      <tr>
        <td colSpan={len + 3} className="text-center text-danger">
          ไม่พบข้อมูล
        </td>
      </tr>
    );

    let followupData = followupUniqByName.map((followupName, index) => {
      let username = followupName.followup_by;
      let fullname = followupName.fullname;
      // lead , reject , cancel, complete
      // let leadCount = this.getCountByCustomerType(
      //   followupSummary,
      //   username,
      //   "lead"
      // );
      // let rejectCount = this.getCountByCustomerType(
      //   followupSummary,
      //   username,
      //   "reject"
      // );
      // let cancelCount = this.getCountByCustomerType(
      //   followupSummary,
      //   username,
      //   "cancel"
      // );
      // let completeCount = this.getCountByCustomerType(
      //   followupSummary,
      //   username,
      //   "complete"
      // );
      return (
        <tr key={index}>
          <td>
            {" "}
            {fullname} : {username}{" "}
          </td>
          <td className="text-center">
            {this.getCountByUser(followupSummary, username)}
          </td>
          {/* <td className="text-center bg-primary font-xl "> {leadCount} </td>
          <td className="text-center bg-danger font-xl"> {rejectCount} </td>
          <td className="text-center bg-warning font-xl"> {cancelCount} </td>
          <td className="text-center bg-success font-xl"> {completeCount} </td> */}

          {this.state.customer_types.map((customer_type, index) => (
            <th
              className="text-center"
              key={index}
              style={{ backgroundColor: "#" + customer_type.followup_color }}
            >
              {this.getCountByCustomerType(
                followupSummary,
                username,
                customer_type.customer_type
              )}
            </th>
          ))}

          <td className="text-center">
            <Link
              to={"/customer/followup/list/?followup_by=" + username}
              target="_blank"
              type="button"
              className="btn btn-info btn-sm btn-block"
            >
              <i className="icon-list">&nbsp;ดูรายละเอียด</i>
            </Link>
          </td>
        </tr>
      );
    });

    let followupRows =
      followupUniqByName.length === 0 ? rowEmpty : followupData;

    let followupSumRows =
      followupUniqByName.length === 0 ? null : (
        <tr>
          <td className="font-weight-bold">รวมตามสถานะ</td>
          <td className="text-center font-weight-bold">
            {this.getSumALl(followupSummary)}
          </td>
          {this.state.customer_types.map((customer_type, index) => (
            <td className="text-center font-weight-bold" key={index}>
              {this.getAllByCustomerType(
                followupSummary,
                customer_type.customer_type
              )}
            </td>
          ))}
          <td className="text-center"></td>
        </tr>
      );

    return (
      <div>
        <div className="row col-12 mt-1">
          <div className="mt-1 ml-4 mr-2">ตามวันที่ติดตาม:</div>
          <div className="form-group col-2 ml-2">
            <BDatePicker
              isDateFill={0}
              //className="ml-2"
              name={"followupDateStart"}
              value={followupDateStart}
              label={""}
              disable={reportBy === "by_all"}
              onUpdateDate={(buddhist_date, christ_date) => {
                this.setState({
                  followupDateStart: christ_date,
                });
              }}
            />
          </div>
          <span className="mt-1">ถึง</span>
          <div className="form-group col-2">
            <BDatePicker
              isDateFill={0}
              //className="form-control d-inline-block ml-2 mr-3"
              name={"followupDateEnd"}
              value={followupDateEnd}
              disable={reportBy === "by_all"}
              label={""}
              onUpdateDate={(buddhist_date, christ_date) => {
                this.setState({
                  followupDateEnd: christ_date,
                });
              }}
            />
          </div>
          <div className="mr-3 ml-3">
            <label
              htmlFor="reportBy"
              className="d-flex align-items-center mb-0"
            >
              <input
                type="radio"
                name="reportBy"
                value="by_date"
                id="by_date"
                className="mr-1"
                checked={reportBy === "by_date"}
                onChange={this.handleInputChange}
              />
              <span>ตามวันที่</span>
            </label>
          </div>
          <div className="mr-3">
            <label
              htmlFor="reportBy"
              className="d-flex align-items-center mb-0"
            >
              <input
                type="radio"
                name="reportBy"
                value="by_all"
                id="by_all"
                className="mr-1"
                checked={reportBy === "by_all"}
                onChange={this.handleInputChange}
              />
              <span>ทั้งหมด</span>
            </label>
          </div>
          {/* <div className="form-group">
            <select
              name="followupBy"
              className="form-control"
              value={followupBy}
              onChange={this.handleInputChange}
            >
              {followupByOptions.length > 0 &&
                followupByOptions.map((sale, index) => (
                  <option key={index} value={sale.value}>
                    {sale.name}
                  </option>
                ))}
            </select>
          </div> */}

          <div className="ml-3 mb-2">
            <Button
              className="mr-1 mb-2"
              color="primary"
              onClick={() => this.loadFollowupSummary()}
            >
              ค้นหา
            </Button>
            {/*  <Button className="mb-2" color="success" onClick={() => {}}>
              Excel
            </Button> */}
          </div>
        </div>

        <table className="table table-striped">
          <thead>
            <tr>
              <th className="text-center">ชื่อผู้ติดตาม/ชื่อผู้ใช้</th>
              <th className="text-center">รวมทั้งหมด</th>
              {/* <th className="text-center">ติดตามลูกค้า(Lead)</th>
              <th className="text-center">ลูกค้ายกเลิก(reject)</th>
              <th className="text-center">ยกเลิกไม่ติดตาม(cancel)</th>
              <th className="text-center">ปิดการขายได้(complete)</th> */}
              {this.state.customer_types.map((customer_type, index) => (
                <th
                  className="text-center"
                  key={index}
                  style={{
                    backgroundColor: "#" + customer_type.followup_color,
                  }}
                >
                  {customer_type.customer_type_name}
                </th>
              ))}
              <th className="text-center">จัดการ</th>
            </tr>
          </thead>
          <tbody>
            {followupRows}
            {followupSumRows}
          </tbody>
        </table>
        <div>
          <strong>สถานะ</strong>
          <br />
          รอ: มีข้อมูลลูกค้าแล้ว แต่ยังไม่ได้ติดต่อ
          <br />
          นัด: ได้นัดหมายแล้ว พร้อมระบุวันที่ชัดเจน
          <br />
          กำลังตัดสินใจ: ติดต่อไปแล้ว แต่รอลูกค้าตัดสินใจ
          <br />
          ปิดการขาย: ปิดการขายเรียบร้อยแล้ว
          <br />
          ลูกค้ายกเลิก: ลูกค้าปฏิเสธไม่ซื้อ
          <br />
          ยกเลิกไม่ติดตาม: ทางบริษัทยกเลิกไม่ติดตาม เช่น ลูกค้าเครดิตไม่ผ่าน
        </div>
      </div>
    );
  }
}

export default CustomerFollowupAdmin;
